import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';

export const faMinus: IconDefinition = {
  prefix: "fas",
  iconName: "minus",
  icon: [448, 512, [], "f068", "M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z"],
};

export default faMinus;
